// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3rK2A","row":"ProcedureTreatmentSummary_row__2gaVP"};